import React from "react";
export default function TotalOrders() {
    const totalOrders = 0;
    return (
        <div className="total-orders-section">
            <div className="total-orders-box">
                <h2>Total Orders Dispatched Till Date!</h2>
                <p className="orders-count">{totalOrders}</p>
            </div>
        </div>
    );
}